import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['input', 'hiddenField'];

  static values = {
    initialData: Object,
    average: Boolean,
  };

  connect() {
    this.rows = Array.isArray(this.initialDataValue?.rows) ? this.initialDataValue.rows : [];

    this.inputTargets.forEach((input) => {
      input.addEventListener('input', () => this.updateValue(input));
    });

    this.updateTotalRow();
    this.syncHiddenField();
  }

  updateValue(input) {
    const key = input.dataset.key;
    const row = this.rows.find((r) => r.key === key);
    if (!row) return;

    if (input.dataset.total === 'true') return;

    row.value = input.value === '' ? null : parseFloat(input.value);
    this.updateTotalRow();
    this.syncHiddenField();
  }

  updateTotalRow() {
    const totalRow = this.rows.find((r) => r.total === true);
    if (!totalRow) return;

    const otherRows = this.rows.filter((r) => r.key !== totalRow.key);
    const total = this.averageValue
      ? this.calculateAverage(otherRows)
      : this.calculateSum(otherRows);

    const hasDecimalInput = this.hasDecimalInputs() || !Number.isInteger(total);
    totalRow.value = this.formatTotalValue(total, hasDecimalInput);

    const totalInput = this.inputTargets.find((input) => input.dataset.total === 'true');
    if (totalInput) {
      totalInput.value = totalRow.value;
    }
  }

  calculateSum(rows) {
    return rows.reduce((sum, r) => sum + (parseFloat(r.value) || 0), 0);
  }

  calculateAverage(rows) {
    const values = rows.map((r) => parseFloat(r.value)).filter((v) => !Number.isNaN(v));
    if (values.length === 0) return 0;

    return values.reduce((sum, v) => sum + v, 0) / values.length;
  }

  formatTotalValue(total, hasDecimalInput) {
    if (!hasDecimalInput) {
      return Math.round(total).toString();
    }

    return total.toFixed(2);
  }

  hasDecimalInputs() {
    return this.inputTargets
      .filter((input) => input.dataset.total !== 'true')
      .some((input) => {
        if (input.value === '') return false;
        const normalized = input.value.replace(',', '.');
        const num = parseFloat(normalized);
        if (Number.isNaN(num)) return false;
        return !Number.isInteger(num);
      });
  }

  syncHiddenField() {
    if (!this.hasHiddenFieldTarget) return;

    const payload = {
      rows: this.rows,
    };

    this.hiddenFieldTarget.value = JSON.stringify(payload);
  }
}
